// extracted by mini-css-extract-plugin
module.exports = {"fileDropWrapper":"style_fileDropWrapper__25qay"};